import homeBreadcrumbs from './homeBreadcrumbs';

const productBreadcrumbs = homeBreadcrumbs.add({ label: 'Products' });
export default productBreadcrumbs;
